import { data } from '../../svg/Payment/data';
import { makeIcon } from '../makeIcon';

export const Payment = makeIcon(data, 'payment', 'Payment');

export default Payment;
